var React = require('react');

function BreathModalCloseBtn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8005 12.5803L25.5976 2.78291C26.2352 2.14563 26.2352 1.11524 25.5976 0.47796C24.9603 -0.15932 23.9299 -0.15932 23.2927 0.47796L13.4953 10.2753L3.69817 0.47796C3.0606 -0.15932 2.0305 -0.15932 1.39322 0.47796C0.755645 1.11524 0.755645 2.14563 1.39322 2.78291L11.1903 12.5803L1.39322 22.3777C0.755645 23.015 0.755645 24.0454 1.39322 24.6826C1.71082 25.0005 2.12841 25.1602 2.5457 25.1602C2.96299 25.1602 3.38028 25.0005 3.69817 24.6826L13.4953 14.8853L23.2927 24.6826C23.6105 25.0005 24.0278 25.1602 24.4451 25.1602C24.8624 25.1602 25.2797 25.0005 25.5976 24.6826C26.2352 24.0454 26.2352 23.015 25.5976 22.3777L15.8005 12.5803Z","fill":"white"}));
}

BreathModalCloseBtn.defaultProps = {"width":"27","height":"26","viewBox":"0 0 27 26","fill":"none"};

module.exports = BreathModalCloseBtn;

BreathModalCloseBtn.default = BreathModalCloseBtn;
